import React from 'react'
import Layout from '../../src/components/layouts'
import HomePage from '../../src/components/pages/Home/default'
import { espanolData } from '../../src/components/pages/Home/consts'
import { jsonLdData } from '../../src/common/constants/jsonLd'
import CustomJsonLd from '../../src/components/shared/CustomJsonLd'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'

export async function getServerSideProps() {
  return {
    props: {},
  }
}

const Index = () => {
  return (
    <>
      <WithSeoOverrides {...espanolData.seoData} />
      <CustomJsonLd
        id={'webPage'}
        data={jsonLdData(
          espanolData?.seoData?.title,
          espanolData?.seoData?.description,
          '/es/espanol/',
          'es-US'
        )}
      />
      <Layout locale="es" isHome={true}>
        <HomePage
          data={{
            ...espanolData,
          }}
          isDefaultLang={false}
        />
      </Layout>
    </>
  )
}

export default Index
